import { Groups } from "@mui/icons-material";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { NAV_ROUTES } from "components/NavigationBar/routes";

export function SupplierNetworkButton() {
  const navigate = useNavigate();

  return (
    <Tooltip
      title="Supplier & Customer Network"
      placement="right"
      TransitionComponent={Zoom}
    >
      <IconButton
        color="inherit"
        onClick={() => navigate(NAV_ROUTES.SUPPLIER_NETWORK)}
      >
        <Groups fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}
